module.exports = __webpack_public_path__ + "rollingReturn.13d2f71a09057e47e33c069268ba9f85.png";